module.exports = __webpack_public_path__ + "static/img/23.84497353.gif";